import React from 'react';

import {
  STORE_CHECKOUT_AI_ICON_SRC,
  type StoreAiPreviewVibe,
} from '../../constants/storeCheckoutAi.constants';

import './StoreReviewItemGalleryFooter.scss';

export interface IStoreReviewItemGalleryFooterProps {
  groupIndex: number;
  itemIndex: number;
  onCreateFlatLays: () => void;
  onCreateModelImages: () => void;
  disabled?: boolean;
}

const StoreReviewItemGalleryFooter: React.FC<IStoreReviewItemGalleryFooterProps> = ({
  groupIndex,
  itemIndex,
  onCreateFlatLays,
  onCreateModelImages,
  disabled = false,
}) => (
  <div className="order-item-gallery-footer">
    <div className="order-item-gallery-footer__actions">
      <button
        type="button"
        className="order-item-gallery-footer__btn"
        disabled={disabled}
        data-testid={`order-item-use-flat-lay-${groupIndex}-${itemIndex}`}
        onClick={onCreateFlatLays}
      >
        <img
          className="order-item-gallery-footer__btn-ai-icon"
          src={STORE_CHECKOUT_AI_ICON_SRC}
          width={16}
          height={16}
          alt=""
          aria-hidden
        />
        <span>Create Flat Lays</span>
      </button>
      <button
        type="button"
        className="order-item-gallery-footer__btn"
        disabled={disabled}
        data-testid={`order-item-use-model-${groupIndex}-${itemIndex}`}
        onClick={onCreateModelImages}
      >
        <img
          className="order-item-gallery-footer__btn-ai-icon"
          src={STORE_CHECKOUT_AI_ICON_SRC}
          width={16}
          height={16}
          alt=""
          aria-hidden
        />
        <span>Create Model Images</span>
      </button>
    </div>
  </div>
);

StoreReviewItemGalleryFooter.displayName = 'StoreReviewItemGalleryFooter';

export type { StoreAiPreviewVibe };

export default StoreReviewItemGalleryFooter;
